export const siteMeta = {
  siteName: "97视频",
  pageName: "97视频网址发布页",
  updatedAt: "2026-10-10 09:30",
  updatedDate: "2026-10-10",
  collectionCount: 6,
  lineCount: 4,
  platformCount: 4,
  statusText: "主线路可用 · 备用入口正常",
  slogan: "最新网址、APP入口、防走失地址，一站找到",
};

export const heroStats = [
  { id: "stat-1", label: "收录可用入口", value: "6", unit: "个" },
  { id: "stat-2", label: "线路类型", value: "4", unit: "类" },
  { id: "stat-3", label: "最近更新", value: "今日", unit: "已核验" },
  { id: "stat-4", label: "覆盖终端", value: "4", unit: "端" },
];